// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "meu-studio-54bbb.firebaseapp.com",
  "projectId": "meu-studio-54bbb",
  "storageBucket": "meu-studio-54bbb.appspot.com",
  "messagingSenderId": "159284441491",
  "appId": "1:159284441491:web:107d56b498ef2468cdf866",
  "measurementId": "G-6Q2XT8WDHZ",
  "apiKey": "AIzaSyCBDJN2cmLismCPk__x0CapCNOhwrcy-MQ"
};
